import React from "react";
import moment from "moment";
const NotesElement = ({ data }) => {
  return (
    <div className="container-fluid d-flex justify-content-between my-2">
      <small
        className="muted-text"
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          width: "80%",
        }}
      >
        <strong>{data?.notes || "-"}</strong>
      </small>
      <small className="muted-text">
        <span>
          {data?.modified ? moment(data?.modified).format("MMM DD, YYYY") : "-"}
        </span>
      </small>
    </div>
  );
};

export default NotesElement;
